import { render, staticRenderFns } from "./PassportLayout.vue?vue&type=template&id=089554f1"
import script from "./PassportLayout.vue?vue&type=script&lang=js"
export * from "./PassportLayout.vue?vue&type=script&lang=js"
import style0 from "./PassportLayout.vue?vue&type=style&index=0&id=089554f1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports